import { ProductInformation, ReviewInformation } from './components';
import { ProductImage } from './components';
import { ProductCardWishListButton } from './components';
import { Box, Flex, Text } from '@chakra-ui/react';
import type { ProductCardProps } from './ProductCard';
import { DiscountBadge } from './components';
import { Condition } from '@/utils/react';

const VerticalProductCard = ({
  onClick,
  showRating = true,
  showRanking = false,
  ranking,
  name,
  brand,
  productImage,
  sku,
  currency,
  rating,
  reviewCount,
  originalPrice,
  salePrice,
}: ProductCardProps) => {
  return (
    <Flex
      direction="column"
      gap={4}
      width="100%"
      cursor="pointer"
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      minWidth="0"
    >
      <Box
        backgroundColor="neutral.5"
        borderRadius="8px"
        height={{ base: '173px', tablet: '222px' }}
        padding={4}
        position="relative"
        width="100%"
        minWidth="0"
      >
        <DiscountBadge originalPrice={originalPrice} salePrice={salePrice} />
        <ProductCardWishListButton sku={sku} position="absolute" right={2} top={2} />
        <ProductImage imageUrl={productImage} name={name} />
        <Condition
          expression={showRanking}
          then={
            <Text color="neutral.10" textStyle="title3" position="absolute" bottom={2} left={3.5}>
              {ranking}
            </Text>
          }
        />
      </Box>
      <Flex direction="column" gap={2} width="100%" minWidth="0">
        <Flex direction="column" gap={1} width="100%" minWidth="0">
          <ProductInformation.Brand>{brand}</ProductInformation.Brand>
          <ProductInformation.Name lineClamp={1}>{name}</ProductInformation.Name>
        </Flex>
        {showRating && <ReviewInformation rating={rating} reviewCount={reviewCount} />}
        <ProductInformation.Price currency={currency} salePrice={salePrice} originalPrice={originalPrice} />
      </Flex>
    </Flex>
  );
};

export default VerticalProductCard;
